import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';
import { User } from '@app/entity';

@Injectable()
export class CheckpointService {
  observer = new Subject<Observer<boolean>>();
  missingFieldsObserver = new Subject<Observer<boolean>>();
  user: User;

  constructor() { }

  createCheckpoint() {
    Observable.create(observer => this.observer.next(observer)).subscribe();
  }

  createMissingFieldsCheckpoint(user?: User) {
    this.user = user || null;
    Observable.create(observer => this.missingFieldsObserver.next(observer)).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/checkpoint.service.ts